<template>
  <modal :show.sync="showParameterPreview" headerClasses="justify-content-center" modalClasses="modal-lg">
    <h4 slot="header" class="title title-up"> {{ $t('parameters_txt') }} </h4>
    <div>
       <div>
        <div class="col-md-12">
         <div class="row">
            <div class="col-md-6">
                <h6><i class="fa fa-tasks"></i> {{ txt.allocation }} </h6>
                <p>{{allocationLabel}}</p>
                <p></p>
            </div>
            <div class="col-md-6">
                  <h6> {{ txt.ratiotxt }} </h6>
                  <p v-if="preview_settings.allocationMethod === 'balRatio'">{{ preview_settings.balRatio }}</p>
                  <p v-if="preview_settings.allocationMethod === 'lotMultiplier'">{{ preview_settings.lotMultiplier }}</p>
                  <p v-if="preview_settings.allocationMethod === 'eqRatio'">{{ preview_settings.eqRatio }}</p>
                  <p v-if="preview_settings.allocationMethod === 'lotMoneyRatio'">{{ preview_settings.lotMoneyRatioX }} {{$t('helper_lotmoneyratioy')}}  {{ settings.lotMoneyRatioY }}</p>
                  <p v-if="preview_settings.allocationMethod === 'fixedLots'">{{ preview_settings.fixedLots }}</p>
                  <p></p>
            </div>
          </div>
          <hr>
        </div>
        <div class="col-md-12" v-if="preview_settings.blockSignalsWithPriceDeviation">
            <div class="row">
              <div class="col-md-6">

              </div>
              <div class="col-md-6">
                <h6><i class="fa fa-refresh"></i> {{ txt.blockSignalsWithPriceDeviationTxt }}</h6>
                <p> {{ (preview_settings.maxPip) ? preview_settings.maxPip : $t('notavailable') }}</p>
              </div>
            </div>
            <hr>
          </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h6><i class="fa fa-signal"></i> {{ txt.assetspairstoreceivesignalstxt }}</h6>
             <p class="mb-0" v-html="label" v-for="label in signalLabel">
                {{label}}
              </p>
            </div>

            <div class="col-md-6">
              <h6><i class="fa fa-signal"></i> {{ txt.receivenewtradesignalstxt }}</h6>
              <p>{{ (preview_settings.receiveNewTradeSignals) ? $t('yestxt') : $t('notxt') }}</p>
            </div>
          </div>
          <hr>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h6><i class="fa fa-flag-checkered"></i> {{ $t('closealltradesatoveralllosstxt') }}</h6>
              <p>{{ (preview_settings.closeAllTradesAtOverallLoss) ? $t('yestxt') : $t('notxt') }}</p>
            </div>

            <div class="col-md-6">

              <p></p>
            </div>

            <div class="col-md-6">
              <h6><i class="fa fa-flag-checkered"></i> {{ $t('maxnumberopenpositionstxt') }}</h6>
              {{preview_settings.maxNumberOpenPositions}}
              <p></p>
            </div>

            <div class="col-md-6">
              <h6><i class="fa fa-flag-checkered"></i> {{ $t('minlotsizetxt') }}</h6>
              {{preview_settings.minLotSize}}
              <p></p>
            </div>
            <div class="col-md-6">
              <h6><i class="fa fa-flag-checkered"></i> {{ $t('maxlotsizetxt') }}</h6>
               {{preview_settings.maxLotSize}}
               <p></p>
            </div>
            <div class="col-md-6">
              <h6><i class="fa fa-flag-checkered"></i> {{ $t('maxaccountmarginusedtxt') }}</h6>
               {{preview_settings.maxAccountMarginUsed}}
              <p></p>
            </div>
          </div>
          <hr>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h6><i class="fa fa-flag"></i> {{ txt.nonewtradesdrawdownabovetxt }}</h6>
              <p>{{ preview_settings.noNewTradesDrawdownAbove }}</p>
              <p></p>
            </div>

            <div class="col-md-6">
              <div v-if="preview_settings.closeAllTradesAtOverallLossChoice == 'lossPercentToCloseProfit'">
                <h6><i class="fa fa-flag"></i> {{ $t('losspercenttocloseprofittxt') }}</h6>
                <p>{{
                    (preview_settings.lossPercentToCloseProfit) ? preview_settings.lossPercentToCloseProfit + '%' : $t('notavailable')
                  }}</p>
              </div>
              <div v-if="preview_settings.closeAllTradesAtOverallLossChoice == 'lossMoneyToCloseProfit'">
                <h6><i class="fa fa-flag"></i> {{ $t('lossmoneytocloseprofittxt') }}</h6>
                <p>{{ (preview_settings.lossMoneyToCloseProfit) ? preview_settings.lossMoneyToCloseProfit : $t('notavailable') }}</p>
              </div>
            </div>
          </div>
          <hr>
        </div>
        <br>
      </div>
    </div>
    <template slot="footer">
      <p-button type="success" link @click="close"> {{ $t('ok') }}</p-button>
    </template>
  </modal>

</template>
<script>

import Vue from "vue";
import Modal from "@/components/UIComponents/Modal.vue";
import {mapActions, mapState} from "vuex";
import {AllocationOptions} from "@/models/parameters/AllocationOptions";
import {SignalOptions} from "@/models/parameters/SignalOptions";

export default {
  name: "ParameterPreview",
  components: {
    Modal
  },
  computed: {
    ...mapState('parameter_preview', ['showParameterPreview', 'preview_settings']),
    ...mapState('strategy_params', ['allocation','sync','signal', 'settings']),
    allocationLabel: {
      get() {
        return this.allocation.method === AllocationOptions.ADVANCED ? this.allocation.advancedMethod.label() : this.allocation.method.label()
      }
    },
    syncLabel: {
      get() {
        return this.sync.option.label()
      }
    },
    signalLabel: {
      get() {
        return this.signal.option === SignalOptions.ADVANCED ?
          [
            this.signal.openCloseOption.label(),
            this.signal.assetOption.label() + this.assetPair,
            this.signal.replicationOption.label()
          ] :
          [
            this.signal.option.label()
          ]
      }
    },
    assetPair: {
      get() {
        if(this.settings.allButTheseAssetsPairsReceiveSignal) {
          return " <b>("+ this.settings.allButTheseAssetsPairsReceiveSignal+")</b>"
        }
        if(this.settings.onlyTheseAssetsPairsReceiveSignal) {
          return " <b>("+ this.settings.onlyTheseAssetsPairsReceiveSignal+")</b>"
        }
        return ""
      }
    }
  },
  data() {
    return {
      txt: {
        allocation: this.$t('allocation'),
        copyOpenTradesTxt: this.$t('copyOpenTradesTxt'),
        assetspairstoreceivesignalstxt: this.$t('assetspairstoreceivesignalstxt'),
        closealltradesatoveralllosstxt: this.$t('closealltradesatoveralllosstxt'),
        nonewtradesdrawdownabovetxt: this.$t('nonewtradesdrawdownabovetxt'),
        param_allocation_advanced_fixed: this.$t('param_allocation_advanced_fixed'),
        copytradessincetxt: this.$t('copytradessincetxt'),
        lossmoneytocloseprofittxt: this.$t('lossmoneytocloseprofittxt'),
        receivenewtradesignalstxt: this.$t('receivenewtradesignalstxt'),
        ratiotxt: this.$t('ratiotxt'),
        param_sync: this.$t('param_sync'),
        blockSignalsWithPriceDeviationTxt: this.$t('blockSignalsWithPriceDeviationTxt'),
      },
    }
  },
  methods: {
    ...mapActions('parameter_preview', ['closeParameterPreviewModal']),
    close(){
      this.closeParameterPreviewModal()
    }
  },

}
</script>
<style scoped>

</style>
